module.exports = __webpack_public_path__ + "img/covea.328dc8e6.png";